import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-modal-student-application-motivation',
    templateUrl: './modal-student-application-motivation.component.html',
    styleUrls: ['./modal-student-application-motivation.component.scss'],
    standalone: false
})
export class ModalStudentApplicationMotivationComponent implements OnInit {

  title = '';
  content = '';
  data: any = {};

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {


  }
}
